export const marker = (
  <svg
    viewBox="0 -0.5 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className="si-glyph si-glyph-pin-location"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g id="SVGRepo_iconCarrier">
      <title>1060</title>
      <defs />
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(3.000000, 0.000000)" fill="#00ff82">
          <path
            d="M5.469,0.021 C2.453,0.021 0.009,2.317 0.009,5.151 C0.009,5.883 0.175,6.579 0.467,7.208 L5.469,15.876 L10.469,7.208 C10.763,6.579 10.928,5.884 10.928,5.151 C10.928,2.316 8.484,0.021 5.469,0.021 L5.469,0.021 Z M5.492,9.042 C3.535,9.042 1.95,7.446 1.95,5.475 C1.95,3.506 3.535,1.91 5.492,1.91 C7.446,1.91 9.031,3.507 9.031,5.475 C9.031,7.446 7.446,9.042 5.492,9.042 L5.492,9.042 Z"
            className="si-glyph-fill"
          />
          <path
            d="M7.979,5.504 C7.979,6.88 6.871,7.996 5.5,7.996 C4.133,7.996 3.023,6.88 3.023,5.504 C3.023,4.131 4.132,3.014 5.5,3.014 C6.87,3.014 7.979,4.131 7.979,5.504 L7.979,5.504 Z"
            className="si-glyph-fill"
          />
        </g>
      </g>
    </g>
  </svg>
);
